/**
 *  SubscriptionAccessory entity class
 */

/**
 * SubscriptionAccessoryFactory
 * returns SubscriptionAccessory entity class
 *
 * @class SubscriptionAccessoryFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SubscriptionAccessory} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SubscriptionAccessoryFactory
 */
/* @ngInject */
export default function SubscriptionAccessoryFactory (Type, Entity, onOffMixin) {
  /* === SubscriptionAccessory class === */

  /**
   * SubscriptionAccessory model
   *
   * @class SubscriptionAccessory
   * @classdesc SubscriptionAccessory model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.SubscriptionAccessory} SubscriptionAccessory entity
   */
  function SubscriptionAccessory () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SubscriptionAccessory.prototype = Object.create(Entity.prototype)
  SubscriptionAccessory.prototype.constructor = SubscriptionAccessory

  /* === SubscriptionAccessory instance methods & fields === */

  Object.assign(SubscriptionAccessory.prototype, {

    /**
     * instance fields
     *
     * @memberof models.SubscriptionAccessory#
     * @type {Object}
     */
    _fields: {
      id: Number,
      accessoryType: String,
      amount: Number,
      currency: 'Currency',
      description: String,
      assignedSubscriptionNames: ['String'],
      enabled: true,
      identifier: String,
      name: String,
      networkId: Number,
      subscriptionType: Type(String('Accessory')),
      user: 'User',
      updateTimestamp: String,
      // temp fields
      $onDisableMessage: String,
      $onDeleteMessage: String,
      $cashedCurrencyId: String,
      accessoryTypeForFilter: String // without $ because st-search-class-by works incorrectly with names that starting '$'
    },

    /**
     * url template
     *
     * @memberof models.SubscriptionAccessory#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/accessories/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.SubscriptionAccessory#
     * @type {String}
     */
    _publicUrlTemplate: 'organizations/{{::networkId}}/monetization-plans/accessories/{{::id}}',

    /**
     * Prepare Accessory
     *
     * @memberof models.SubscriptionAccessory#
     * @override
     */
    _prepare: function () {
      this.accessoryTypeForFilter = this.accessoryType || 'NO_TYPE'

      this.$cashedCurrencyId = this.currency?.id
      const message = this.assignedSubscriptionNames.length
        ? ('This accessory is assigned to the Subscription(s) ' + this.assignedSubscriptionNames.join(', ') + '. Please pay attention that if it’s used in pricing rules, they will be changed and disabled or deleted.<br><br>') : ''
      this.$onDisableMessage = message + 'Are You sure You want to disable Accessory?'
      this.$onDeleteMessage = message + 'Are you sure you want to delete Accessory permanently?'
    }

  }, onOffMixin)

  /* === SubscriptionAccessory static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(SubscriptionAccessory, Entity)
  SubscriptionAccessory._name = 'SubscriptionAccessory'
  SubscriptionAccessory.init()

  // permissions
  SubscriptionAccessory.access = {
    view: 'viewSubscription createSubscriptionPayment |',
    create: 'createSubscription',
    edit: 'editSubscription',
    delete: 'deleteSubscription'
  }

  return SubscriptionAccessory
}
